/** Client-side pagination over an in-memory array (filter/search upstream of it). */
import { useState } from 'react';

interface PaginationState<T> {
  /** Zero-based, clamped to the last page when the set shrinks. */
  page: number;
  pageCount: number;
  pageItems: T[];
  setPage: (page: number) => void;
}

export const usePagination = <T>(items: T[], pageSize: number): PaginationState<T> => {
  const [rawPage, setPage] = useState(0);
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const page = Math.min(rawPage, pageCount - 1);
  return {
    page,
    pageCount,
    setPage,
    pageItems: items.slice(page * pageSize, (page + 1) * pageSize),
  };
};
